<template>
  <div class="padding-10">
    <Toolbar v-if="isAdmin || isDataEntry || isDataEntryAndDispatcher"></Toolbar>
    <Table></Table>
  </div>
</template>
<script>
import Toolbar from "../components/zipcodes/Toolbar.vue";
import Table from "../components/zipcodes/Table.vue";
export default {
  components: {
    Toolbar,
    Table,
  },
  mounted() {},
};
</script>

<style></style>
